// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import ManagedAccordionSection from "@insite/mobius/AccordionSection/ManagedAccordionSection";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { StyledClickable } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import { typographyInvertColorStyles } from "@store/Themes/common/mixins/typography";
import { accordionFooterSectionProps } from "@store/Themes/common/props/accordionFooter";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
// Kishigo --->
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
// <--- Kishigo

const enum fields {
    contentTitle = "contentTitle",
    firstColumnTitle = "firstColumnTitle",
    secondColumnTitle = "secondColumnTitle",
    thirdColumnTitle = "thirdColumnTitle",
}

const footerLinkStyles = () => linkAltStyles();

const footerTitleStyles = () => css`
    ${({ theme }) => css`
        ${spacingStyles(null, "0.8em")}
        font-size: ${theme.design.typography.size.large};
        font-weight: ${theme.design.typography.weight.bold};
        line-height: ${theme.design.typography.lineHeight.semi};

        ${breakpoint("sm")} {
            font-size: ${theme.design.typography.size.larger};
        }

        ${breakpoint("xl")} {
            font-size: ${theme.design.typography.size.largest};
        }
    `}
`;

const legalVerticalGap = pxToRem(8);
const legalHorizontalGap = pxToRem(16);
const legalFlexWrapperStyles = () => css`
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    flex-direction: column;
    gap: ${legalVerticalGap} ${legalHorizontalGap};
    align-items: center;
    text-align: center;

    ${breakpoint("md")} {
        flex-direction: row;
        text-align: left;
    }
`;
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
    // Starter Custom Code
    widgetWrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    gridContainer?: GridContainerProps;
    columnsGridItem?: GridItemProps;
    columnsGridContainer?: GridContainerProps;
    columnGridItem?: GridItemProps;
    columnTitle?: TypographyPresentationProps;
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
    contentGridItem?: GridItemProps;
    contentTitle?: TypographyPresentationProps;
    hidden?: HiddenProps;
    separatorGridItem?: GridItemProps;
    legalWrapper?: InjectableCss;
    legalInnerWrapper?: InjectableCss;
    legalZoneGroupWrapper?: InjectableCss;
    legalZoneWrapper?: InjectableCss;
    // Kishigo
    footerContainer?: InjectableCss;
    contactContainer?: InjectableCss;
    contactWrapper?: InjectableCss;
    linklistWrapper?: InjectableCss;
    leftGridItem?: GridItemProps;
    centerGridItem?: GridItemProps;
    aboutGridItem?: GridItemProps;
    socialGridItem?: GridItemProps;
    bottomLeftGridItem?: GridItemProps;
    bottomRightGridItem?: GridItemProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    // Kishigo --->
    logoGridItem: {
        width: 12,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: [12, 12, 4, 4, 4],
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    footerContainer: {
        css: css`
            padding: ${pxToRem(50)} 0;
            background-color: ${getColor("primary.main")};
            color: ${getColor("common.background")};
        `,
    },
    contactContainer: {
        css: css`
            background-color: ${getColor("common.backgroundAlt")};
        `,
    },
    linklistWrapper: {
        css: css`
            ${siteWidthStyles()}
        `,
    },
    contactWrapper: {
        css: css`
            padding: ${pxToRem(15)} 0;
            ${siteWidthStyles()}
            color: ${getColor("common.background")};
        `,
    },
    leftGridItem: {
        width: [12, 3, 3, 3, 3],
        align: "top",
        css: css`
            padding-bottom: 0;
        `,
    },
    centerGridItem: {
        width: [12, 4, 3, 4, 4],
        align: "top",
        css: css`
            padding-top: ${pxToRem(47.5)};
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-top: 0;
                        `,
                    ],
                    mediaOptions.minMax,
                )}
        `,
    },
    aboutGridItem: {
        width: [12, 4, 2, 2, 2],
        align: "top",
    },
    socialGridItem: {
        width: [12, 12, 4, 3, 3],
        align: "top",
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-top: ${pxToRem(30)};
                            padding-left: 0;
                        `,
                        css`
                            padding-top: ${pxToRem(30)};
                            padding-left: 0;
                        `,
                    ],
                    mediaOptions.minMax,
                )}
        `,
    },
    bottomLeftGridItem: {
        width: [12, 12, 8, 8, 8],
        align: "middle",
        css: css`
            margin-top: ${pxToRem(100)};
        `,
    },
    bottomRightGridItem: {
        width: [12, 12, 4, 4, 4],
    },
    // <--- Kishigo
};

const FooterContainer: FC<OwnProps> = ({
    id,
    extendedStyles,
    // Starter Custom Code
    fields: { contentTitle, firstColumnTitle, secondColumnTitle, thirdColumnTitle },
}) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    /* Starter Custom Code - Start */
    const showLegalLeft = useZoneIsActive(id, "LegalLeft");
    const showLegalMiddle = useZoneIsActive(id, "LegalMiddle");
    const showLegalRight = useZoneIsActive(id, "LegalRight");

    return (
        //  Kishigo --->
        <>
            <StyledWrapper {...styles.footerContainer}>
                <StyledWrapper {...styles.linklistWrapper}>
                    <GridContainer>
                        <GridItem {...styles.leftGridItem}>
                            <Zone zoneName="categories" contentId={id} />
                        </GridItem>
                        <GridItem {...styles.centerGridItem}>
                            <Zone zoneName="categories2" contentId={id} />
                        </GridItem>

                        <GridItem {...styles.aboutGridItem}>
                            <Zone zoneName="about" contentId={id} />
                        </GridItem>

                        <GridItem {...styles.socialGridItem}>
                            <Zone zoneName="social" contentId={id} />
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.contactContainer}>
                <StyledWrapper {...styles.contactWrapper}>
                    <GridContainer>
                        <GridItem {...styles.bottomLeftGridItem}>
                            <Zone zoneName="FooterLegalZone" contentId={id} />
                        </GridItem>

                        <GridItem {...styles.bottomRightGridItem}>
                            <Zone zoneName="FooterLegalLinks" contentId={id} />
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            </StyledWrapper>
        </>
        // <--- Kishigo
    );
    /* Starter Custom Code - End */
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
        /* Starter Custom Code - Start */
        fieldDefinitions: [
            {
                name: fields.contentTitle,
                displayName: "Content title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.firstColumnTitle,
                displayName: "First Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
            {
                name: fields.secondColumnTitle,
                displayName: "Second Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
            {
                name: fields.thirdColumnTitle,
                displayName: "Third Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
        ],
        /* Starter Custom Code - End */
    },
};

export default footerContainer;
